module.exports = __webpack_public_path__ + "static/media/altPoster.fc5338dc.png";